import React from 'react';
import { NavigationRoute, useNavigation, useRouterPath } from 'shared-utils';
import { useYearlyRootNavigation } from 'utils/yearStore';
import Breadcrumb from 'components/Breadcrumb';
import { DashboardNavigation, CampaignNavigation } from 'screens/routes';

type Props = {
    label: string;
};

const CampaignDetailsBreadcrumb: React.FC<Props> = ({ label }: Props) => {
    const homePath = useRouterPath(DashboardNavigation());
    const [rootNavigations] = React.useState({ campaignNav: CampaignNavigation });
    const { campaignNav } = useYearlyRootNavigation(rootNavigations);
    const campaignPath = useRouterPath(campaignNav);
    const { push: navigate } = useNavigation();

    const triggerNav = React.useCallback((route: NavigationRoute) => (event: React.MouseEvent<any>) => {
        if (event.ctrlKey || event.metaKey) return;

        event.preventDefault();
        navigate(route);
    }, [navigate]);

    return (
        <Breadcrumb>
            <Breadcrumb.Home
                key="bc-home"
                to={homePath ?? undefined}
                onClick={triggerNav(DashboardNavigation())}
            />
            <Breadcrumb.Item
                key="bc-campaign"
                to={campaignPath ?? undefined}
                onClick={triggerNav(campaignNav)}
            >
                Tournées
            </Breadcrumb.Item>
            <Breadcrumb.Item key="bc-campaign-details">{label}</Breadcrumb.Item>
        </Breadcrumb>
    );
};

export default CampaignDetailsBreadcrumb;
